$(function() {

  // 首頁輪播
  if ( $('#indexBanner').length != 0 ) {
    var indexBanner = new Swiper('#indexBanner', {
      effect: 'fade',
      autoplay: {
        delay: 5000,
      },
      loop: true,
      peed: 1000,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
    });
  }

  // 最新消息輪播
  if ( $('#homeNewsSwiper').length != 0 ) {
    var homeNewsSwiper = new Swiper("#homeNewsSwiper", {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        prevEl: ".home-news-swiper-wrap .swiper-button-prev",
        nextEl: ".home-news-swiper-wrap .swiper-button-next",
      },
      breakpoints: {
        1025: { // >= 1025px 時
          slidesPerView: 2.5,
          spaceBetween: 68,
          slidesOffsetAfter: 80,
        },
        641: { // >= 641px 時
          slidesPerView: 1.5,
          spaceBetween: 38,
          slidesOffsetAfter: 60,
        }
      },
    });
  }

  // 合作夥伴
  if ( $('#partnersMarquee').length != 0 ) {
    // 跑馬燈
    const $partnersMarquee = $('#partnersMarquee');
    const $content = $partnersMarquee.find('.marquee-content');
    const $slides = $content.find('.marquee-item');
    cloneMarqueeItems();
    function cloneMarqueeItems() {
      // 重置
      $content.removeClass('play');
      let $cloneItem = $content.find('.marquee-item.clone');
      $cloneItem.each(function(index, el) {
        $(el).remove();
      });
      // 複製項目
      let screenWidth = $(window).width();
      let totalWidth = 0;
      $slides.each(function() {
        totalWidth += $(this).outerWidth(true);
      });
      let copyCount = Math.round( (screenWidth * 3) / totalWidth );
      for ( let i = 0 ; i < copyCount ; i ++ ) {
        $content.append( $slides.clone().addClass('clone') );
      }
      // 開始播放
      setTimeout(()=>{
        $content.addClass('play');
      }, 500);
    }

    let partnersMarqueeResizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(partnersMarqueeResizeTimer);
      partnersMarqueeResizeTimer = setTimeout(function() {
        cloneMarqueeItems();
      }, 300);
    });

  }

});